import React from 'react';
import PropTypes from 'prop-types';
import { Field, withForm } from './finalForm';
import LinkContainer from '../components/LinkContainer';
import Prompt from '../components/Prompt';

import ErrorMessage from '../components/ErrorMessage';
import renderField from './render/renderField';
import renderFileField from './render/renderFileField';
import RenderQuestionsField from './render/renderQuestionsField';
import normalizePhone from './normalize';
import {
  email,
  matchPattern,
  maxLength,
  phone,
  required,
  resume,
} from './validators';
import renderCheckbox from './render/renderCheckbox';


const maxLength10000 = maxLength(10000);
const maxLength200 = maxLength(200);
const matchPatternNumber = matchPattern(/^[ 0-9]+$/, 'Можно вводить только числа');

class CreateResponseForm extends React.Component {
  constructor(props) {
    super(props);
    const { vacancy } = props;
    this.state = {
      vacancy,
    };
  }

  onChangeVacancy = (event) => {
    this.setState({ vacancy: event.value });
  };

  validateResponseForm = (fieldType) => {
    switch (fieldType) {
      case 'tel': return phone;
      case 'email': return email;
      case 'textarea': return maxLength10000;
      case 'file': return resume;
      case 'number': return matchPatternNumber;
      default: return maxLength200;
    }
  };

  getFields = (vacancy) => {
    const { fields } = vacancy;

    const result = [];
    fields.forEach((field) => {
      result.push((
        <Field
          key={field.name}
          type={field.type}
          name={field.type === 'file' ? `userFile_${field.name}` : field.name}
          component={field.type !== 'file' ? renderField : renderFileField}
          label={field.type !== 'file' ? field.placeholder
            : `Прикрепить ${field.placeholder && field.placeholder.toLowerCase()}`}
          validate={field.required ? [this.validateResponseForm(field.type), required]
            : this.validateResponseForm(field.type)}
          rows="10"
          normalize={field.name === 'phone' ? normalizePhone : undefined}
          accept={field.type === 'file' ? '.pdf, .doc, .docx' : undefined}
          info={field.type === 'file' ? 'Допустимы файлы в формате .pdf, .doc, .docx, размером не более 10 МБ.'
            : undefined}
        />
      ));
    });

    return result;
  };

  render() {
    const {
      handleSubmit,
      submitting,
      dirty,
      submitSucceeded,
      submitFailed,
      questions,
    } = this.props;

    const { vacancy } = this.state;
    const { policy_url } = vacancy;

    return (
      <form onSubmit={handleSubmit} encType="multipart/form-data" className="createResponse">
        <Prompt
          when={dirty && !submitSucceeded}
          message="Изменения отклика не сохранены. Вы уверены, что хотите покинуть страницу?"
        />
        {(vacancy) && (
          <>
            <div className="response-form__field">
              {this.getFields(vacancy)}
            </div>
            <RenderQuestionsField
              vacancy={vacancy}
              questions={questions}
            />
            <div className="response-form__field">
              <Field
                name="acceptRights"
                type="checkbox"
                label={
                  (
                    <a
                      className="hrs-check-box-confirmation-link"
                      href={policy_url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Я даю своё согласие на обработку персональных данных
                    </a>
                  )
                }
                classNames="ms-0"
                component={renderCheckbox}
                validate={[required]}
              />
            </div>
          </>
        )}
        <div className="buttons-container">
          <button
            className="button"
            type="submit"
            disabled={submitting || !vacancy}
          >
            Создать
          </button>
          <LinkContainer
            to="/all-vacancies"
          >
            <button type="button" className="button button_color_dark-blue">Отмена</button>
          </LinkContainer>
        </div>
        {submitFailed && <div className="form-error">Не все поля заполнены корректно</div>}
        <ErrorMessage errorName="createResponseError" />
      </form>
    );
  }
}

CreateResponseForm.propTypes = {
  questions: PropTypes.arrayOf(PropTypes.object).isRequired,
  handleSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  dirty: PropTypes.bool.isRequired,
  submitSucceeded: PropTypes.bool.isRequired,
  submitFailed: PropTypes.bool.isRequired,
  vacancy: PropTypes.object.isRequired,
};

export default withForm({
  form: 'createResponse',
  resetSubmitFailedOnChange: true,
})(CreateResponseForm);
